import React from 'react'
import MonthButton from '../../components/buttons/MonthButton'
import format from '../../../../utilities/format'
import { parseDate } from '../../../../utilities/helpers'

const Months = ({
  selected,
  months,
  displayedMonths,
  monthsAhead,
  onMonthClick,
}) => {

  return (
    <div className="move-months-list gap-3">
      {Object.keys(months).map((item, key) => (
        <MonthButton
          key={key}
          title={format(parseDate(months[item].start), 'LLL')}
          subtitle={format(parseDate(months[item].start), 'yyyy')}
          selected={selected.includes(+format(parseDate(months[item].start), 'M'))}
          onClick={() => onMonthClick(format(parseDate(months[item].start), 'M'))}
        />
      )).slice(0, monthsAhead)}
    </div>
  )
}

export default Months
